import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AppConfig } from "./environement";
import "./index.css";
import NerdApp from "./nerdApp";
import { store } from "./redux/store";

document.title = AppConfig.app.title || "Rhapsody Booklet";
const favIcon = document.getElementById("favicon");
if (favIcon !== null && favIcon instanceof HTMLLinkElement)
  favIcon.href = AppConfig.app.favicon || "";
const container = document.getElementById("root");

if (container != null) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <NerdApp />
      </Provider>
    </BrowserRouter>
  );
}
